// extracted by mini-css-extract-plugin
export default {"previewWrapper":"M7UHS","previewImage":"mmb9G"};